import React from "react";
import StoreSystemIdDetails from "../component/StoreSystemIdDetails";

const StoreSystemIdDetailsContainer = ({ pageId }) => (<StoreSystemIdDetails pageId={pageId} />)

export default StoreSystemIdDetailsContainer;
